export default "__VITE_ASSET__46077c67__"